/* eslint-disable class-methods-use-this */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["topbar", "triggerElement"];

  connect() {
    this.checkPosition();
    window.addEventListener("scroll", this.checkPosition.bind(this));
  }

  checkPosition() {
    const { top: topDistance, height } = this.triggerElementTarget.getBoundingClientRect();
    const bottomDistance = topDistance + height;

    if (bottomDistance < 0) {
      this.topbarTarget.classList.add("show");
    } else {
      this.topbarTarget.classList.remove("show");
    }
  }
}
